<div fxFlex="100" fxFlex.gt-sm="60" fxFlexOffset.gt-sm="20"
     style="margin-left: 10px; margin-right: 10px; margin-top: 20px;" fxLayout="wrap row" fxLayoutAlign="center">
  <mat-card style="width: 100%;">
    <mat-card-header>
      <mat-card-title>
        Vergleichsrechnung
      </mat-card-title>
    </mat-card-header>
    <mat-card-content>
      <table class="w3-table-all input-right" style="max-width: 550px; float:left;">
        <thead>
        <th colspan="3" style="text-align: center;">
          <div style="margin-left:-100px;">Vorgaben</div>
        </th>
        </thead>
        <thead>
        <th></th>
        <th>Ist-Zustand</th>
        <th>Simulations-Vorgaben</th>
        </thead>
        <tbody>
          <tr>
            <td>Umsatz</td>
            <td>
              <ejs-numerictextbox format="c0" currency="EUR" locale="de" [(ngModel)]="settings_ist.umsatz" step="100000" (ngModelChange)="updateData()"></ejs-numerictextbox>
            </td>
            <td>
              <ejs-numerictextbox format="c0" currency="EUR" locale="de" [(ngModel)]="settings_soll.umsatz" step="100000" (ngModelChange)="updateData()"></ejs-numerictextbox>
            </td>
          </tr>
          <tr>
            <td>Umsatzanteil Direkt Ist</td>
            <td>
              <ejs-numerictextbox format="p0" [step]="0.01" locale="de" [(ngModel)]="settings_ist.umsatzanteil_direkt" (ngModelChange)="updateData()"></ejs-numerictextbox>
            </td>
            <td>
              <ejs-numerictextbox format="p0" [step]="0.01" locale="de" [(ngModel)]="settings_soll.umsatzanteil_direkt" (ngModelChange)="updateData()"></ejs-numerictextbox>
            </td>
          </tr>
          <tr>
            <td>Durchschnittsbestellung GH</td>
            <td>
              <ejs-numerictextbox format="c0" currency='EUR' locale="de" [(ngModel)]="settings_ist.durchschnittsbestellung_gh" (ngModelChange)="updateData()"></ejs-numerictextbox>
            </td>
            <td>
              <ejs-numerictextbox format="c0" currency='EUR' locale="de" [(ngModel)]="settings_soll.durchschnittsbestellung_gh" (ngModelChange)="updateData()"></ejs-numerictextbox>
            </td>
          </tr>
          <tr>
            <td>Netto-Spanne GH</td>
            <td>
              <ejs-numerictextbox format="p0" [step]="0.1" locale="de" [(ngModel)]="settings_ist.netto_spanne_gh" (ngModelChange)="updateData()"></ejs-numerictextbox>
            </td>
            <td>
              <ejs-numerictextbox format="p0" [step]="0.1" locale="de" [(ngModel)]="settings_soll.netto_spanne_gh" (ngModelChange)="updateData()"></ejs-numerictextbox>
            </td>
          </tr>
          <tr>
            <td>Netto-Spanne Direktbestellung</td>
            <td>
              <ejs-numerictextbox format="p0" [step]="0.1" locale="de" [(ngModel)]="settings_ist.netto_spanne_direkt" (ngModelChange)="updateData()"></ejs-numerictextbox>
            </td>
            <td>
              <ejs-numerictextbox format="p0" [step]="0.1" locale="de" [(ngModel)]="settings_soll.netto_spanne_direkt" (ngModelChange)="updateData()"></ejs-numerictextbox>
            </td>
          </tr>
          <tr>
            <td>Anzahl Zusatzbestellung neu</td>
            <td>

            </td>
            <td>
              <ejs-numerictextbox format="n" step="100" locale="de" [(ngModel)]="settings_soll.anzahl_zusatzbestellungen_neu" (ngModelChange)="updateData()"></ejs-numerictextbox>
            </td>
          </tr>
          <tr>
            <td>Mindest-Bestellwert</td>
            <td>
              <ejs-numerictextbox format="c0" currency="EUR" locale="de" [(ngModel)]="settings_ist.mindest_bestellwert" (ngModelChange)="updateData()"></ejs-numerictextbox>
            </td>
            <td>
              <ejs-numerictextbox format="c0" currency="EUR" locale="de" [(ngModel)]="settings_soll.mindest_bestellwert" (ngModelChange)="updateData()"></ejs-numerictextbox>
            </td>
          </tr>
          <tr>
            <td>Übertragungskapazität / Stunde</td>
            <td>
              <ejs-numerictextbox format="n" locale="de" [(ngModel)]="settings_ist.uebertragungskapazitaet_stunde" (ngModelChange)="updateData()"></ejs-numerictextbox>
            </td>
            <td>

            </td>
          </tr>
          <tr>
            <td>Anzahl Mitarbeiter für Übertragung</td>
            <td>
              <ejs-numerictextbox format="n1" locale="de" [showSpinButton]="false" [(ngModel)]="settings_ist.mitarbeiter_uebertragung" readonly></ejs-numerictextbox>
            </td>
            <td>

            </td>
          </tr>
        </tbody>
      </table>
      <table class="w3-table-all input-right" style="max-width: 550px; float:left; margin-left: 4px;">
        <thead>
        <th colspan="3" style="text-align: center;">
          <div>Direktbestellungen manuell vs DigiBest</div>
        </th>
        </thead>
        <thead>
        <th></th>
        <th>Ist-Situation</th>
        <th>Soll-Situation neu</th>
        </thead>
        <tbody>
        <tr>
          <td>Gesamt-Umsatz</td>
          <td>
            <ejs-numerictextbox format="c0" currency="EUR" locale="de" [showSpinButton]="false" [(ngModel)]="berechnung_ist.gesamt_umsatz" readonly></ejs-numerictextbox>
          </td>
          <td>
            <ejs-numerictextbox format="c0" currency="EUR" locale="de" [showSpinButton]="false" [(ngModel)]="berechnung_soll.gesamt_umsatz" readonly></ejs-numerictextbox>
          </td>
        </tr>
        <tr>
          <td>Umsatz GH</td>
          <td>
            <ejs-numerictextbox format="c0" currency="EUR" locale="de" [showSpinButton]="false" [(ngModel)]="berechnung_ist.umsatz_gh" readonly></ejs-numerictextbox>
          </td>
          <td>
            <ejs-numerictextbox format="c0" currency="EUR" locale="de" [showSpinButton]="false" [(ngModel)]="berechnung_soll.umsatz_gh" readonly></ejs-numerictextbox>
          </td>
        </tr>
        <tr>
          <td>Umsatz Direkt Ist</td>
          <td>
            <ejs-numerictextbox format="c0" currency="EUR" locale="de" [showSpinButton]="false" [(ngModel)]="berechnung_ist.umsatz_direkt_ist" readonly></ejs-numerictextbox>
          </td>
          <td>
            <ejs-numerictextbox format="c0" currency="EUR" locale="de" [showSpinButton]="false" [(ngModel)]="berechnung_soll.umsatz_direkt_ist" readonly></ejs-numerictextbox>
          </td>
        </tr>
        <tr>
          <td>Anzahl Bestellungen GH</td>
          <td>
            <ejs-numerictextbox format="n0" locale="de" [showSpinButton]="false" [(ngModel)]="berechnung_ist.anzahl_bestellungen_gh" readonly></ejs-numerictextbox>
          </td>
          <td>
            <ejs-numerictextbox format="n0" locale="de" [showSpinButton]="false" [(ngModel)]="berechnung_soll.anzahl_bestellungen_gh" readonly></ejs-numerictextbox>
          </td>
        </tr>
        <tr>
          <td>Anzahl Direktbestellungen Ist</td>
          <td>
            <ejs-numerictextbox format="n0" currency="EUR" locale="de" [showSpinButton]="false" [(ngModel)]="berechnung_ist.anzahl_direktbestellungen_ist" readonly></ejs-numerictextbox>
          </td>
          <td>
            <ejs-numerictextbox format="n0" currency="EUR" locale="de" [showSpinButton]="false" [(ngModel)]="berechnung_soll.anzahl_direktbestellungen_ist" readonly></ejs-numerictextbox>
          </td>
        </tr>
        <tr>
          <td>Rohgewinn Direktbestellungen</td>
          <td>
            <ejs-numerictextbox format="c0" currency="EUR" locale="de" [showSpinButton]="false" [(ngModel)]="berechnung_ist.rohgewinn_direktbestellungen" readonly></ejs-numerictextbox>
          </td>
          <td>
            <ejs-numerictextbox format="c0" currency="EUR" locale="de" [showSpinButton]="false" [(ngModel)]="berechnung_soll.rohgewinn_direktbestellungen" readonly></ejs-numerictextbox>
          </td>
        </tr>
        <tr>
          <td>Rohgewinn GH-Bestellungen</td>
          <td>
            <ejs-numerictextbox format="c0" currency="EUR" locale="de" [showSpinButton]="false" [(ngModel)]="berechnung_ist.rohgewinn_gh_bestellungen" readonly></ejs-numerictextbox>
          </td>
          <td>
            <ejs-numerictextbox format="c0" currency="EUR" locale="de" [showSpinButton]="false" [(ngModel)]="berechnung_soll.rohgewinn_gh_bestellungen" readonly></ejs-numerictextbox>
          </td>
        </tr>
        <tr>
          <td>Gesamt-Rohgewinn</td>
          <td>
            <ejs-numerictextbox format="c0" currency="EUR" locale="de" [showSpinButton]="false" [(ngModel)]="berechnung_ist.rohgewinn_gesamt" readonly></ejs-numerictextbox>
          </td>
          <td>
            <ejs-numerictextbox format="c0" currency="EUR" locale="de" [showSpinButton]="false" [(ngModel)]="berechnung_soll.rohgewinn_gesamt" readonly></ejs-numerictextbox>
          </td>
        </tr>
        <tr>
          <td>Umsatz-Anteil Direktbestellungen</td>
          <td>
            <ejs-numerictextbox format="p2" locale="de" [showSpinButton]="false" [(ngModel)]="berechnung_ist.umsatz_anteil_direktbestellungen" readonly></ejs-numerictextbox>
          </td>
          <td>
            <ejs-numerictextbox [showSpinButton]="false" [(value)]="berechnung_soll.umsatz_anteil_direktbestellungen" locale="de"
                                format="p2" [showSpinButton]="false" readonly>
            </ejs-numerictextbox>
          </td>
        </tr>
        <tr>
          <td>Gesamt-Stundenzahl für Übertragung in WWS</td>
          <td>
            <ejs-numerictextbox format="n1" locale="de" [showSpinButton]="false" [(ngModel)]="berechnung_ist.stundenzahl_uebertrag" readonly></ejs-numerictextbox>
          </td>
          <td>
            <ejs-numerictextbox format="n1" locale="de" [showSpinButton]="false" [(ngModel)]="berechnung_soll.stundenzahl_uebertrag" readonly></ejs-numerictextbox>
          </td>
        </tr>
        <tr>
          <td>Anteiliges Gehalt (€)</td>
          <td>
            <ejs-numerictextbox format="c0" currency="EUR" locale="de" [showSpinButton]="false" [(ngModel)]="berechnung_ist.anteiliges_gehalt" readonly></ejs-numerictextbox>
          </td>
          <td>
            <ejs-numerictextbox format="c0" currency="EUR" locale="de" [showSpinButton]="false" [(ngModel)]="berechnung_soll.anteiliges_gehalt" readonly></ejs-numerictextbox>
          </td>
        </tr>
        <tr>
          <td>Rohgewinn II (€)</td>
          <td>
            <ejs-numerictextbox format="c0" currency="EUR" locale="de" [showSpinButton]="false" [(ngModel)]="berechnung_ist.rohgewinn_ii" readonly></ejs-numerictextbox>
          </td>
          <td>
            <ejs-numerictextbox format="c0" currency="EUR" locale="de" [showSpinButton]="false" [(ngModel)]="berechnung_soll.rohgewinn_ii" readonly></ejs-numerictextbox>
          </td>
        </tr>
        <tr>
          <td>Mehrertrag durch DigiBest (€)</td>
          <td>

          </td>
          <td>
            <ejs-numerictextbox [value]="berechnung_soll.mehrertrag_digibest"
                                format="c0"
                                currency="EUR"
                                locale="de"
                                readonly
                                style="font-weight: bolder !important;"
                                [showSpinButton]="false"
                                [class.greenText]="berechnung_soll.mehrertrag_digibest > 0"
                                [class.redText]="berechnung_soll.mehrertrag_digibest <= 0"></ejs-numerictextbox>
          </td>
        </tr>
        </tbody>
      </table>
    </mat-card-content>
  </mat-card>
</div>
